import v from "../dom-utils/getWindow.js";
var n = {
  passive: !0
};
function d(e) {
  var r = e.state, t = e.instance, o = e.options, i = o.scroll, a = i === void 0 ? !0 : i, c = o.resize, l = c === void 0 ? !0 : c, p = v(r.elements.popper), f = [].concat(r.scrollParents.reference, r.scrollParents.popper);
  return a && f.forEach(function(s) {
    s.addEventListener("scroll", t.update, n);
  }), l && p.addEventListener("resize", t.update, n), function() {
    a && f.forEach(function(s) {
      s.removeEventListener("scroll", t.update, n);
    }), l && p.removeEventListener("resize", t.update, n);
  };
}
const m = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: d,
  data: {}
};
export {
  m as default
};
